export default __webpack_public_path__ + "static/media/Initiate's Wraps of the Crescent.9902949f.jpg";